import { Component, Input } from '@angular/core';
import { TemplatesDataProvider } from '@services/data-services/templates-data-service/templates.data.service';
import { Subject } from 'rxjs/Subject';
import { MailsDataProvider } from '@services/email/mails.data.service';
import { EmailServiceProvider } from '@services/email/email-service/email.service';
import { FileUploadServiceProvider } from '@services/files/file-upload-service/file-upload.service';
import { ClientsDataServiceProvider } from '@services/client/clients.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { ValidationProvider } from '@services/helpers/validation.service';
import { QuotesDataProvider } from '@services/quote/quotes-data-service/quotes.data.service';

interface MessageData {
	emailSubject: string;
	emailText: string;
	emailTo: string;
	emailCc?: string;
	attachmentsData?: any;
	templateId?: any;
}

@Component({
	selector: 'modal-send-quote',
	template: require('./modal-send-quote.html'),
	styles: [require('./modal-send-quote.scss')]
})
export class ModalSendQuoteComponent {
	@Input() email;
	@Input() jobId: number;
	@Input() quoteId: number;
	activeView: string;
	showCcField = false;
	disableBtnOnSend = false;
	clientsNames: any;
	mailData: any = {};
	client: any = {};
	items: any;
	contract: any = {};
	isClientSearch = false;
	sendMessageData: MessageData = {
		emailSubject: '',
		emailText: '',
		emailTo: '',
		emailCc: ''
	};
	emailCcObj: any;
	private emptyAttachmentsData = {
		attachments: [],
		filesSize: 0
	};
	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private templateRequestsService: TemplatesDataProvider,
		private mailsDataService: MailsDataProvider,
		private emailService: EmailServiceProvider,
		private fileUploadService: FileUploadServiceProvider,
		private clientsDataService: ClientsDataServiceProvider,
		private messageService: MessageService,
		private validationService: ValidationProvider,
		private quotesDataService: QuotesDataProvider
	) {}

	ngOnInit() {
		this.templateRequestsService
			.getTemplates('all')
			.takeUntil(this.unsubscribe)
			.subscribe(data => this.setDefaultContractEmail(data));
	}
	ngAfterViewInit() {
		this.sendMessageData.emailTo = this.email;
	}
	onChange(event) {}
	private setMailData(data) {
		const { client, invoiceId } = data;
		this.client = client;
		this.quoteId = invoiceId;
		this.mailData = JSON.parse(JSON.stringify(data));
		this.mailData.id = client.id;
		this.sendMessageData = this.emailService.setMessageData(data, client);
		this.clearAttachments();
		if (data.mailSignature) {
			this.sendMessageData.emailText += `<br><br>${data.mailSignature}`;
		}
	}
	toggleViewCc() {
		this.showCcField = true;
	}
	private setDefaultContractEmail(emails: Array<any>): void {
		if (emails !== undefined && emails !== null && emails.length) {
			this.mailData.chosenEmail =
				emails.find(
					item => item.emailTemplateType === 'QUOTE_EMAIL_TEMPLATE'
				) || {};
			// this.mailData.chosenEmail = JSON.parse(JSON.stringify(template));

			this.mailData.emails = JSON.parse(JSON.stringify(emails));
			this.changeEmail(this.mailData.chosenEmail);
		}
	}
	changeEmail(newObj) {
		if (!newObj || !newObj.id) {
			this.resetMailFields();
			return false;
		}
		this.templateRequestsService
			.getTemplates('full_template', newObj.id)
			.subscribe(
				email => this.updateEmail(email),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}
	setEmail(site) {
		let stringEmail = JSON.parse(JSON.stringify(site.name));
		stringEmail = stringEmail.substring(
			stringEmail.indexOf('(') + 1,
			stringEmail.length - 1
		);

		this.sendMessageData.emailCc = stringEmail;
		this.emailCcObj = Object.assign({ email: stringEmail }, site);
	}

	findAllMatchingClientNames(search) {
		this.clientsDataService
			.searchClient(search)
			.subscribe(
				result => this.findClientSuccessCallback(result),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}
	private findClientSuccessCallback(clients) {
		if (clients && clients.length !== 0) {
			this.clientsNames = clients;
			this.isClientSearch = true;
		}
	}
	private chooseEmailCC(email) {
		this.sendMessageData.emailCc = email;
	}

	closeModal() {
		this.templateRequestsService
			.getTemplates('all')
			.takeUntil(this.unsubscribe)
			.subscribe(data => this.setDefaultContractEmail(data));
		this.showCcField = false;
	}
	private resetMailFields() {
		this.sendMessageData.emailSubject = '';
		this.sendMessageData.emailText = '';

		if (this.mailData.mailSignature) {
			this.sendMessageData.emailText += `<br><br>${
				this.mailData.mailSignature
			}`;
		}
		this.clearAttachments();
	}
	private updateEmail(emailTemplate) {
		if (
			emailTemplate.storedAttachments &&
			emailTemplate.storedAttachments.length
		) {
			this.sendMessageData.attachmentsData = {
				attachments: this.fileUploadService.convertAttachmentsToShow(
					emailTemplate.storedAttachments
				)
			};
		} else {
			this.clearAttachments();
		}
		this.sendMessageData.emailSubject = emailTemplate.subject || '';
		this.sendMessageData.emailText = emailTemplate.text || '';
	}
	private clearAttachments(): void {
		this.sendMessageData.attachmentsData = JSON.parse(
			JSON.stringify(this.emptyAttachmentsData)
		);
	}
	sendQuoteEmail() {
		this.disableBtnOnSend = true;
		const { attachmentsData } = this.sendMessageData;

		if (!this.emailService.isAttachmentsValid(attachmentsData)) {
			this.disableBtnOnSend = false;
			return false;
		}

		if (
			this.validationService.isStringEmpty(this.sendMessageData.emailSubject)
		) {
			this.disableBtnOnSend = false;
			this.messageService.showToaster('e_10', 'emailTemplate');
			return false;
		}

		this.sendMessageData.emailText = this.sendMessageData.emailText || '';
		this.sendMessageData.emailText = this.emailService.resetSignatureLink(
			this.sendMessageData.emailText
		);

		const storedFiles = attachmentsData.attachments.filter(file => file.id);
		const uploadedFiles = attachmentsData.attachments.filter(file => !file.id);

		const sendMessageData = this.gatherDataToSend();

		const dataToSend = {
			sendMessageData,
			storedFiles,
			uploadedFiles
		};

		this.makeSendEmailRequest(dataToSend);
	}
	private gatherDataToSend() {
		const emailCC2save = this.showCcField ? this.sendMessageData.emailCc : '';

		return {
			emailTo: this.sendMessageData.emailTo,
			emailCc: emailCC2save,
			emailText: this.sendMessageData.emailText,
			emailSubject: this.sendMessageData.emailSubject,
			templateId: this.mailData.chosenEmail
				? this.mailData.chosenEmail.id
				: null,
			quoteId: this.quoteId,
			jobId: this.jobId
		};
	}
	private makeSendEmailRequest(data) {
		this.quotesDataService
			.sendQuoteEmail(data)
			.finally(() => (this.disableBtnOnSend = false))
			.subscribe(
				() => this.successSendEmail(),
				result => this.errorSendMessage(result)
			);
	}
	private successSendEmail() {
		this.disableBtnOnSend = false;
		this.messageService.showToaster('s_10', 'payments');
		$('#sendQuoteModal').modal('hide');
	}

	private errorSendMessage({ status, data }) {
		const errorMessage = data.errorMessage;

		if (status >= 400 && status < 500 && errorMessage) {
			if (errorMessage.includes('Email address inactive')) {
				this.messageService.showToaster(
					'e_1',
					'generalValidation',
					this.sendMessageData.emailTo
				);
			} else if (this.activeView.includes('JobProfilePage')) {
				this.messageService.showToaster('e_3', 'editQuote');
			} else {
				this.messageService.showToaster('e_2', 'general', errorMessage);
			}
		} else {
			this.messageService.showToaster('e_0', 'general');
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/quote/modals/modal-send-quote/modal-send-quote.ts